export const FETCH_MODELS = "FETCH_MODELS";

export const fetchModels = (categoryId, brandId) => ({
    type: FETCH_MODELS,
    categoryId, brandId
});